@let contact = data();

<section class="section-contact">
  <h2 class="section-contact__title">{{ contact.title }}</h2>
  <p class="section-contact__intro" [innerText]="contact.intro"></p>

  <form class="section-contact__form" [formGroup]="form" (submit)="onSubmit()">
    <pai-contact-form [form]="form" [appearance]="contact.inputAppearance ?? 'fill'" />

    <button pai-button type="submit" [disabled]="form.invalid" [isLoading]="submitAction.isPending()">
      <span>{{ 'ContactForm.Submit.Label' | translate }}</span>
    </button>

    @if (submitAction.hasError()) {
      <p class="section-contact__form-message">{{ 'ContactForm.ErrorMessage' | translate }}</p>
    } @else if (submitAction.hasResult()) {
      <p class="section-contact__form-message">{{ 'ContactForm.SuccessMessage' | translate }}</p>
    }
  </form>

  <div class="section-contact__address">
    <div class="section-contact__address-inner" [paiLexicalRichText]="contact.address"></div>
  </div>
</section>
